import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const SignUpIntro = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: 'Join Team Agua Rotterdam',
      description: 'Ready to start your Brazilian Jiu-Jitsu journey? Sign up through our membership partner to get started with unlimited training in Rotterdam.',
    },
    nl: {
      title: 'Schrijf je in bij Team Agua Rotterdam',
      description: 'Klaar om je Brazilian Jiu-Jitsu reis te beginnen? Meld je aan via onze lidmaatschapspartner om te starten met onbeperkt trainen in Rotterdam.',
    },
  };

  const text = content[language] || content.en;

  return (
    <div className="signup-intro">
      <h1 className="signup-title">{text.title}</h1>
      <p className="signup-description">{text.description}</p>
    </div>
  );
};

export default SignUpIntro;
